// 查询当前机构详情
import request from '../request.js';
export function baseInfo() {
    return request({
        url:'/module-auth/orgInfo/baseInfo',
        method:'get'
    })
}